import { render, staticRenderFns } from "./family-list-page.vue?vue&type=template&id=892c96e0&"
import script from "./family-list-page.vue?vue&type=script&lang=js&"
export * from "./family-list-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports